import React from 'react';

// Types
import { User } from 'Shared/constants/types';

// Hooks
import { useBaTracking } from 'Shared/tracking/use-ba-tracking';
import { useCreateOrSendBa } from 'Shared/utils/hooks/use-create-or-send-ba';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

// Components
import BaseCta from './BaseCta';
import { Illustrations } from 'Wpds/components/illustration';
import ExternalLinksConstants from 'Shared/constants/ExternalLinks.constants';

type Props = {
  user: User;
};

const SendBa = ({ user, ...rest }: Props) => {
  const { trackSendAssessmentButtonClick } = useBaTracking();
  const { sendBaEmail, isCreatingBaLink } = useCreateOrSendBa({ user: user, isTakingBaForSelf: false });
  const { tr } = useTranslation();

  const handleButtonClick = async () => {
    trackSendAssessmentButtonClick();
    await sendBaEmail();
  };

  return (
    <BaseCta
      title={tr('perform.user_ba_profile_snapshot.send_ba.title', user.firstName)}
      illustration={Illustrations.take_ba}
      description={tr('perform.user_ba_profile_snapshot.send_ba.description')}
      buttonText={tr('perform.user_ba_profile_snapshot.send_ba.button_text')}
      buttonSize="lg"
      footerText={tr('perform.user_ui.user_ba_profile_snapshot.learn_more')}
      footerLink={ExternalLinksConstants.learn_more_about_taking_ba}
      onButtonClick={handleButtonClick}
      loading={isCreatingBaLink}
      {...rest}
    />
  );
};

export default SendBa;
